// Card 2095 - once the show is Finalized (USEF competition complete) a class
// that was never uploaded (skip-flagged through Finalize, un-skipped after)
// sits in DRAFT, and the bulk Publish/Finalize buttons are locked for good.
// USEF's spec says a completed competition accepts no further uploadclass, so
// the only path left is submitcorrectedclass: the same Correct action, which
// report-api's correctUsefClass now accepts for a DRAFT class when the show is
// already submitted. Pre-finalize the bulk Publish covers a DRAFT class, so
// this never shows then.
//
// `complete` must be passed independently of derivedState: PublishResults'
// classDerivedState returns "error" BEFORE its incomplete check, so a stale
// in-memory error on a class that is no longer complete would otherwise still
// show the button. `status` is the raw federation status (a never-uploaded
// class has none, or DRAFT: same test as PublishResults' classCanUpload).
export function classCanPublishAsCorrection({ status, showIsSubmitted, derivedState, skipped, complete }) {
  return (
    showIsSubmitted === true &&
    skipped !== true &&
    complete === true &&
    (!status || status === "DRAFT") &&
    (derivedState === "ready" || derivedState === "error" || derivedState === "publishing")
  );
}
